const isOneOf = (domain: string, ...domainList: string[]) => {
  return domainList.some((d) => domain.includes(d))
}

export const hardcodePaygateContact = (domain: string): Partial<S3Types.paygate_contact> => {
  if (isOneOf(domain, 'jennbra.us')) {
    return {
      address: '590 Durham Ridge Dr. NW, Lilburn GA 30047',
      email: 'contact@jennbra.us',
      phone: '+1 (818) 617-2527'
    }
  }

  if (isOneOf(domain, 'exsecret.com')) {
    return {
      address: '9010 Commerce Center Drive, Valencia, CA 91355',
      email: 'support@exsecret.com',
      phone: ' +1 (267) 477-7480'
    }
  }

  // if (isOneOf(domain, 'upwingsbra.com', 'pettest.onselless.com')) {
  //   return {
  //     address: '5th floor, Pax Sky building, 63-65 Ngo Thi Nham Str., Hanoi, Vietnam',
  //     email: 'support@shophelp.org',
  //     phone: '(+84) 24 6688 7429'
  //   }
  // }

  // if (isOneOf(domain, 'charmingbra.us')) {
  //   return {
  //     address: '1, Voat Phnum, Doun Penh, Phnom Penh, Cambodia'
  //   }
  // }

  if (
    isOneOf(
      domain,
      'sofiabra.com',
      'scarletbra.com',
      'elymoon.com',
      'her-lovely.com',
      'skylardresser.com',
      'estherdresser.com',
      'mellowbra.com',
      'rosemarybra.com',
      'ladiesbyq.com',
      'andcasually.com'
    )
  ) {
    return {
      address:
        '402, Floor 4, Huaxia Bank Building, 61 Guoxing Avenue, Meilan District, Haikou City, Hainan Province, 570000'
    }
  }
  return {}
}

export const hardcodeSellpage = (domain: string, page: S3Types.page) => {
  if (isOneOf(domain, 'carlacharm.com', 'jessiebra.com')) {
    if (page?.setting?.settings?.general?.title) {
      page.setting.settings.general.title = page.setting.settings.general.title.replace(
        /^UpWing/,
        'Jessie'
      )
    }
  }
}

// export const hardcodeStaticPage = (
//   domain: string
// ): {
//   [static_slug: string]: S3Types.default_store_static_page
// } => {
//   if (isDomainHardCodeStaticPage(domain)) {
//     return {
//       'return-policy': {
//         title: 'Return & Refund Policy',
//         items: [
//           {
//             title: '',
//             contents: [
//               'By placing an order, you confirm that you have read, understood, and accepted the following policy.'
//             ]
//           },
//           {
//             title: 'Returns:',
//             contents: [
//               '<span class="shop__name">{{ shop }}</span> offers a 7-day quality guarantee for damaged/faulty item(s). Customers can return defective item(s) for refund, replacement, or exchange. Please initiate your request of choice in our contact portal <a href="/contact?ref=return-policy">here</a>. <u>In cases where the item is confirmed to be faulty by our team</u>, we will cover return shipping.',
//               'For non-quality or non-defect-related issues, you may request exchanges within 7 days of the order delivery date. Simply <a href="/contact?ref=return-policy">contact us</a> and we will be more than happy to accommodate you.',
//               'Returned item(s) for refund, exchanges, or replacements must be in brand new condition in which they are received. You will be notified by email about your return status. If you are eligible for a refund, the refund amount will be credited to your original payment method within 3-7 days. <u>Please note the original shipping charge is non-refundable.</u>'
//             ]
//           },
//           {
//             title: 'Reserved Rights Regarding Returns',
//             contents: [
//               '<span class="shop__name">{{ shop }}</span> reserves the right to solely define and limit, refuse, and/or reject returns from customers at any time due to:',
//               '<span class="item__disc">An irregular or excessive returns history indicative of “wardrobing”;</span>',
//               '<span class="item__disc">An irregular or excessive returns history involving worn, altered, laundered, damaged, or missing items; or,</span>',
//               '<span class="item__disc">Potential fraudulent or criminal activity.</span>'
//             ]
//           },
//           {
//             title: 'Cancellations or changes:',
//             contents: [
//               'Orders are automatically processed within 6 hours from time of order confirmation. Please <a href="/contact?ref=return-policy">contact us</a> ASAP and within the following time period for cancellations and changes. ',
//               '<span class="item__disc">To cancel your order, please do so within 6 hours from time of order confirmation. Late requests may incur fees.</span>',
//               '<span class="item__disc">To make changes to your order (change color or size), please do so within 24 hours from time of order confirmation.</span>',
//               '<span class="item__disc">Order modification requests after 24 hours from time of order confirmation may not be accommodated.</span>'
//             ]
//           }
//         ]
//       },
//       faqs: {
//         title: 'FAQs',
//         items: [
//           {
//             title: 'WHERE DO YOU SHIP FROM?',
//             contents: [
//               '<span class="shop__name">{{ shop }}</span> team works with top manufacturers worldwide to bring together the best-valued and high-quality products to our customers. Your order can be shipped anywhere from the continental USA, Vietnam, India, China, or other countries. We partner with USPS, DHL, and Purolator to deliver your packages and they will be handled with the utmost care and expediency. '
//             ]
//           },
//           {
//             title: 'WHEN WILL MY ORDER SHIP?',
//             contents: [
//               "Once an order is placed, you'll receive an email notification confirming we've received it. We will process your order 6 hours after successful payment. Order processing usually takes 1-3 days. During high volume or crisis periods, processing times may take an additional 2-4 days. ",
//               'Once shipped, you will receive email notifications and may log in to our website or app for real-time tracking. Note that some orders may be sent using multiple parcels. In these cases, you will receive multiple emails and tracking numbers.'
//             ]
//           },
//           {
//             title: 'HOW LONG WILL IT TAKE FOR MY ORDER TO ARRIVE? ',
//             contents: [
//               'All standard shipments are usually delivered within 7-15 business days from the ship date.'
//             ]
//           },
//           {
//             title: 'WHAT IS YOUR RETURN & EXCHANGE POLICY? ',
//             contents: [
//               'For more detailed information and instructions, please visit <a href="/static/return-policy">our return policies</a>.'
//             ]
//           },
//           {
//             title: 'WHAT PAYMENT OPTIONS DO YOU ACCEPT?',
//             contents: [
//               'Credit/debit card: you can choose to pay with Visa, Mastercard, American Express, Discover, PayPal. Learn more about our payment option <a href="/static/payment-methods">here</a>.'
//             ]
//           }
//         ]
//       },
//       'shipping-policy': {
//         title: 'Shipping Policy',
//         items: [
//           {
//             title: 'OUR WAREHOUSE LOCATIONS',
//             contents: [
//               '<span class="shop__name">{{ shop }}</span> team works with top manufacturers worldwide to bring together the best-valued and high-quality products to our customers. Your order can be shipped anywhere from the continental USA, Vietnam, India, China, or other countries. We partner with USPS, DHL, and Purolator to deliver your packages and they will be handled with the utmost care and expediency. '
//             ]
//           },
//           {
//             title: 'ORDER PROCESSING TIME',
//             contents: [
//               "Once an order is placed, you'll receive an email notification confirming we've received it. We will process your order 6 hours after successful payment. Order processing usually takes 1-3 days. During high volume or crisis periods, processing times may take an additional 2-4 days.",
//               'Once shipped, you will receive email notifications and may log in to our website or app for real-time tracking. Note that some orders may be sent using multiple parcels. In these cases, you will receive multiple emails and tracking numbers.'
//             ]
//           },
//           {
//             title: 'SHIPPING TIME FRAME',
//             contents: [
//               'All standard shipments are usually delivered within 7-15 business days from the ship date.'
//             ]
//           }
//         ]
//       }
//     }
//   }
//   return {}
// }

export const customConfig = (domain: string, subpath: string) => {
  if (isOneOf(domain, 'nasboutiques.com', 'mychloebra.com')) {
    return {
      pixelShow: 'fast',
      isProductPage: isProductPage(subpath)
    }
  }
  return {}
}

const isProductPage = (subpath: string) => {
  return !([
    'checkout',
    'thankyou',
    'orders',
    'contact',
    'trackings',
    'cs-notify',
    'static'
  ] as any[]).includes(subpath)
}

export const isDomainHardCodeStaticPage = (domain?: string) => {
  return isOneOf(
    domain || (process.browser ? window?.location?.hostname : ''),
    // 'bestflexpants.com',
    // 'flexstridespants.com',
    // 'flexstrides.com',
    // 'mycloverapparel.com'
    'testshop.onselless.dev',
    'noerror.onselless.dev',
    'skyesecret.com'
  )
}

export const isShowVideo = (domain?: string) => {
  return isOneOf(
    domain || (process.browser ? window?.location?.hostname : ''),
    // 'bestflexpants.com',
    // 'flexstridespants.com',
    // 'flexstrides.com',
    // 'mycloverapparel.com'
    'testshop.onselless.dev',
    'noerror.onselless.dev'
  )
}

export const isActiveSpeedCurve = (domain?: string) => {
  return isOneOf(domain || (process.browser ? window?.location?.hostname : ''), 'carlacharm.us')
}
